var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3906 33.323L33.3365 30.3782L45.8562 42.898L42.9104 45.8428L30.3906 33.323Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 37.5001C30.0381 37.5001 37.5 30.0382 37.5 20.8334C37.5 11.6287 30.0381 4.16675 20.8333 4.16675C11.6286 4.16675 4.16666 11.6287 4.16666 20.8334C4.16666 30.0382 11.6286 37.5001 20.8333 37.5001Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8021 36.8125L36.7469 33.8667L45.8052 42.925L42.8594 45.8709L33.8021 36.8125Z",
    fill: "#37474F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 34.3751C28.3122 34.3751 34.375 28.3123 34.375 20.8334C34.375 13.3546 28.3122 7.29175 20.8333 7.29175C13.3545 7.29175 7.29166 13.3546 7.29166 20.8334C7.29166 28.3123 13.3545 34.3751 20.8333 34.3751Z",
    fill: "#6956E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0208 14.7916C26.25 12.7083 23.6458 11.4583 20.8333 11.4583C18.0208 11.4583 15.4167 12.7083 13.6458 14.7916C13.2292 15.2083 13.3333 15.9374 13.75 16.2499C14.1667 16.6666 14.8958 16.5624 15.2083 16.1458C16.6667 14.4791 18.6458 13.5416 20.8333 13.5416C23.0208 13.5416 25 14.4791 26.4583 16.1458C26.6667 16.3541 26.9792 16.5624 27.2917 16.5624C27.5 16.5624 27.8125 16.4583 27.9167 16.3541C28.3333 15.9374 28.3333 15.2083 28.0208 14.7916Z",
    fill: "#BBDEFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ec5a63521656ecbd3f0157a428ecb21f.svg";
export { ForwardRef as ReactComponent };